import React from "react";
import useRoute from "../../router/useRoute";
import Password from "./Password";
import SignUp from "./SignUp";

const ResetPassword = () => {
  const { params } = useRoute();
  const { resetPwdToken: resetPwdTokenString } = params;

  return resetPwdTokenString ? <Password token={resetPwdTokenString} /> : <SignUp />;
};

export default ResetPassword;
